import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/group-young-people-working-together-project_23-2148461544.jpg';

function ABAWD() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Able-Bodied Adults Without Dependents" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Able-Bodied Adults Without Dependents (ABAWD) and Mandatory Work Participants</h4>
              <p>
                The Supplemental Nutrition Assistance Program (SNAP) includes work requirements for certain recipients. 
                Able-Bodied Adults Without Dependents (ABAWD) and Mandatory Work Participants must meet specific work 
                requirements to maintain their SNAP eligibility.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Who is Subject to Work Requirements?</h3>
              <div style={{ marginTop: '20px' }}>
                <div style={{ marginBottom: '24px' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>ABAWD Definition</h5>
                  <p style={{ color: '#666', marginBottom: 0 }}>An Able-Bodied Adult Without Dependents (ABAWD) is a person who is between 18 and 49 years old, is physically and mentally able to work, has no dependents, and is not exempt from work requirements.</p>
                </div>
                <div style={{ marginBottom: '0' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Mandatory Work Participants</h5>
                  <p style={{ color: '#666', marginBottom: 0 }}>Certain SNAP recipients may be required to participate in work activities as a condition of receiving benefits. This includes individuals who are not exempt from work requirements.</p>
                </div>
              </div>
            </div>

            <div className="department-details-box">
              <div className="department-details-policy">
                <span>
                  Work requirements help promote self-sufficiency and employment.
                </span>
              </div>
              <p>
                The State of GTS supports SNAP recipients in meeting work requirements through employment services, 
                job training programs, and work activity opportunities.
              </p>
            </div>

            <div className="department-details-benefits-inner-box">
              <h3>Work Requirements</h3>
              <p>
                ABAWDs and Mandatory Work Participants must meet one of the following requirements:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Work at least 80 hours per month</strong> in paid employment
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Participate in a work program</strong> for at least 80 hours per month
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Participate in a workfare program</strong> for the number of hours assigned
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Participate in a combination of work and work activities</strong> totaling at least 80 hours per month
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Exemptions from Work Requirements</h4>
              <p>
                The following individuals are exempt from ABAWD work requirements:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Children under 18 years old
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Adults 50 years old or older
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Individuals who are physically or mentally unable to work
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Pregnant women
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Individuals caring for a child under 6 years old or an incapacitated person
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Students enrolled at least half-time
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Individuals receiving unemployment compensation
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Individuals participating in a drug or alcohol treatment program
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Time Limits</h4>
              <p>
                ABAWDs can receive SNAP benefits for a maximum of 3 months in a 36-month period if they do not meet 
                work requirements. This time limit helps encourage employment and self-sufficiency.
              </p>
              <p style={{ marginTop: '15px' }}>
                <strong>Note:</strong> The 36-month period is a rolling period, and months of eligibility are counted 
                when an ABAWD receives benefits without meeting work requirements.
              </p>
            </div>

            <div className="department-details-policy-box">
              <h4>Work Activity Programs</h4>
              <p>
                The State of GTS offers various work activity programs to help SNAP recipients meet work requirements, including:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Job search and job placement assistance
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Job training and skills development programs
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Work experience programs
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Community service opportunities
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Education and training programs
                </li>
              </ul>
            </div>

            <div>
              <Link to="/department/family-services/snap">
              <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }}/>
              Back to SNAP
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default ABAWD;

